import Indigo from "../../../../src/components/RenderImgs/indigoagImgs";
import * as React from 'react';
export default {
  Indigo,
  React
};